import styled from 'styled-components/macro'

import { Title as TitleBase } from '../../styled'
import { mq } from 'styles/mq'

export const Title = styled(TitleBase).attrs({ 'data-thread': '' })`
  &::before {
    width: 189.9rem;
    height: 70.8rem;
    right: 100%;
    bottom: 0.7em;
    margin: 0 var(--container-spacing);
    mask-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1898.3 707.26'%3E%3Cpath class='cls-1' d='m1898.28,706.35c-111.76,4.8-228.47-32.85-301.59-117.21-64.25-74.13-89.14-175.6-150.95-251.78-13.12-16.17-28.66-31.61-48.5-37.92-16.58-5.27-34.49-3.65-51.74-1.34-71.57,9.57-148.05,29.19-213.11-2.12-61.16-29.43-94.3-95.95-118.28-159.44-15.66-41.46-31.24-86.32-66.99-112.51-39.11-28.65-92.76-27.31-139.91-16.06-95.18,22.71-195.08,119.69-255.1,179.72-60.88,54.47-190.49,106.6-319.6,122.66-53.98,6.72-111.24,9.88-160.34-13.53C23.08,273.4-13.3,214.98,5.57,163.96' fill='none' stroke='black' stroke-width='1.5px' vector-effect='non-scaling-stroke' stroke-miterlimit='10' /%3E%3C/svg%3E");

    ${mq.smallOnly} {
      display: none;
    }
  }
`
